export default __webpack_public_path__ + "static/media/herbalism.c4b01cab.png";